import { useSelector } from 'react-redux';
import G from './Getters';

export default function useGetter(getter,...args){

  return useSelector(state => {
    
    
    let fun = G[getter];
    
    if( !fun ){
      throw Error(`No Getter '"+getter+"' found.`);
    }
    return G[getter](state,...args);
  })

}
